import RegisterForm from "../Components/forms/RegisterForm";
import { Link } from "react-router-dom";

const Register = () => {
    return (
        <div className="auth-shell relative min-h-screen overflow-hidden bg-zinc-950 text-white">
            <div
                className="pointer-events-none absolute inset-0 opacity-70"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 15% 20%, rgba(255, 74, 110, 0.20), transparent 34%), radial-gradient(circle at 85% 15%, rgba(59, 130, 246, 0.14), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                }}
            />

            <div className="relative mx-auto flex min-h-screen max-w-6xl items-center justify-center px-4 pb-12 pt-24">
                <section className="w-full max-w-2xl rounded-3xl border border-zinc-800 bg-zinc-900/65 p-8 shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                    <h2 className="text-3xl font-bold text-white">Crear cuenta</h2>
                    <p className="mt-2 text-sm text-zinc-300">
                        Registrate para comprar y gestionar tus entradas.
                    </p>

                    <div className="mt-7">
                        <RegisterForm />
                    </div>

                    <div className="mt-7 text-sm">
                        <Link
                            to="/login"
                            className="text-zinc-300 transition-colors hover:text-white"
                        >
                            ¿Ya tenés cuenta? Iniciá sesión
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Register;
